const UserManagerReducer = (state = {}, action) => {
    switch (action.type) {
        case "getUserDataSuccess":
            return Object.assign({}, state, {
                UsersList: action.data,
            });
            break;
        case "getUserDetailsSuccess":
            return Object.assign({}, state, {
                UserDetails: action.data,
            });
            break;
        case "getshipNameListSuccess":
            return Object.assign({}, state, {
                shipNameList: action.data.ships,
            });
            break;
        case "getshipNameListFailure":
            return Object.assign({}, state, {
                shipNameList: action.data.ships,
            });
            break;
        case "userSearch":
            return Object.assign({}, state, {
                userSearch: action.data,
            });
            break;
        default: {
            return state;
        }
    }
};
export default UserManagerReducer;
